<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
  <div class="navBox"><Nav curNavId="1" pathUrl='gbzntjs' @circle="clickNav"/></div>
  <div class="leftBg"></div>
  <div class="left_txt">
    <div class="l_txt_middle">
      <h6>项目简介</h6>
      <div class="l_txt_nt">
        <img src="../assets/img/plant/img.jpg" />
        <div class="textScroll">
          <txtScroll>
            <div v-for="item in textList" :key="item.id" class="scroll_item">
              {{ item }}
            </div>
          </txtScroll>

        </div>
      </div>
    </div>
    <div class="l_txt_top">
      <!-- <leftBar /> -->
      <h6>建设项目分布图</h6>
      <div class="sp">
        <img src="../assets/img/gbzntyj/dtSmall.png"  class="smallimg" @click="bigImg" />
        <!-- <div
          class="sp_n"
          v-for="(item, index) in videoList"
          :key="index"
          @click="videoClick(index)"
        >
          <img :src="item.img" />
          <div class="imgbg">{{ item.name }}</div>
        </div> -->
      </div>
    </div>

    <div class="l_txt_bottom">
      <!-- <h6>建设项目分布图</h6> -->
      <div class="l_txt_b_n">
        <leftBar />
        <!-- <leftPie /> -->
        <!-- <div class="ld"><ldt /></div>
            <div class="cl"><dczz /></div> -->
            
      </div>
    </div>
  </div>
  <div class="db_dh"></div>
  <div class="d_h_n_r">
    <div class="sbx_b" @click="buttonClick(1)">
      <div class="xz_sbx"></div>
      <div class="xz_bj"></div>
      <div class="b_name">环境监测</div>
    </div>
    <div class="sbx_b" @click="buttonClick(2)">
      <div class="xz_sbx"></div>
      <div class="xz_bj"></div>
      <div class="b_name">性诱测报</div>
    </div>
    <div class="sbx_b" @click="buttonClick(3)">
      <div class="xz_sbx"></div>
      <div class="xz_bj"></div>
      <div class="b_name">杀虫灯</div>
    </div>
    <div class="sbx_b" @click="buttonClick(4)">
      <div class="xz_sbx"></div>
      <div class="xz_bj"></div>
      <div class="b_name">测报灯</div>
    </div>
    <div class="sbx_b" @click="buttonClick(5)">
      <div class="xz_sbx"></div>
      <div class="xz_bj"></div>
      <div class="b_name">孢子仪</div>
    </div>
    <div class="sbx_b" @click="buttonClick(6)">
      <div class="xz_sbx"></div>
      <div class="xz_bj"></div>
      <div class="b_name">水电双计</div>
    </div>
  </div>
  <!-- <div class="map_dao">
    <div @click="buttonClick(1)">培训</div>
    <div @click="buttonClick(2)">农机服务</div>
    <div @click="buttonClick(3)">农也技术</div>
    <div @click="buttonClick(4)">无人机</div>
    <div @click="buttonClick(5)">测图</div>
    <div @click="buttonClick(6)">金融</div>
  </div> -->
  <footer1 />
  <popBg title="高标准农田" :popShow="popShow" @hiddlen="popHiddlen">
    <!-- <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="videoList[curVideoIndex].options.src"  :type="videoList[curVideoIndex].options.type"  :autoPlay="true"/> -->
    <div style="width: 100%; height: 100%" v-if="AccessToken != ''">
      <iframe
        :src="videoList[curVideoIndex].options.src + AccessToken"
        width="100%"
        height="100%"
        id="ysOpenDevice"
        allowfullscreen
      >
      </iframe>
    </div>
  </popBg>
  <div class="imgPopBg" v-if="imgShow">
    <div class="imgPop  animate__animated animate__zoomIn">
      <!-- <img src="../assets/img/gbzntjsyzt/img/dt2.png" v-if="curimgIndex==1" /> -->
      <img src="../assets/img/gbzntyj/dt1.png" />
    </div>
    <div class="closeIcon" @click.stop="clickImg">×</div>
  </div>
  <CircleNav :isShow="circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/map.json";
import ldt from "../components/gbzntyj/ldt.vue";
import dczz from "../components/gbzntyj/dczz.vue";
import leftBar from "../components/gbzntyj/leftBar.vue";
// import leftPie from "../components/gbzntyj/leftBar.vue";
import footer1 from "../components/footer.vue";
import txtScroll from "../components/txtScroll.vue";
import popBg from "../components/popBg.vue";
import Nav from "../components/nav.vue";
import CircleNav from "@/components/circleNav.vue";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      textList: [
        // {
        //   title:
        //     "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，",
        // },
        // {
        //   title:
        //     "深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续",
        // },
        // {
        //   title:
        //     "发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加",
        // },
        // {
        //   title:
        //     "强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、",
        // },
        // {
        //   title:
        //     "县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，",
        // },
        // {
        //   title:
        //     "经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇",
        // },{
        //   title:
        //     "的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准",
        // },{
        //   title:
        //     "农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。",
        // },
      ],

      videoList: [
        {
          img: require("@/assets/img/gbzntyj/video1.jpg"),
          name: "高标准农田1",
          // "options": {
          //   src: "https://open.ys7.com/v3/openlive/AZ4145835_1_2.m3u8?expire=1740968991&id=686158739457310720&t=a2df278ad8ed05b87e2ba098d8e5aab421d37bad2cb06b2d858df79527b8f47d&ev=100", //视频源
          //   type: "m3u8", //视频类型
          // }
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
        },
        {
          img: require("@/assets/img/gbzntyj/video2.jpg"),
          name: "高标准农田2",
          // "options": {
          //   src: "https://open.ys7.com/v3/openlive/AY7450743_1_2.m3u8?expire=1740969297&id=686160021995081728&t=087c295c6d3b3acfaaf8d4cf32d46981de8713298a252bca3065ab24b89dfb63&ev=100", //视频源
          //   type: "m3u8", //视频类型
          // }
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
        },
        {
          img: require("@/assets/img/gbzntyj/video3.jpg"),
          name: "高标准农田3",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/E53817475/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
        },
        {
          img: require("@/assets/img/gbzntyj/video1.jpg"),
          name: "高标准农田4",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
        },
      ],
      curVideoIndex: 0,
      popShow: false,
      config: {
        // header: ['<span style="color:#038259;">网上名称</span>', '<span style="color:#038259;">归属地</span>', '<span style="color:#038259;">店铺数据</span>'],
        data: [
          ["1号地块", "120次", "88人", "100min"],
          ["2号地块", "170次", "88人", "100min"],
          ["3号地块", "150次", "88人", "100min"],
          ["4号地块", "220次", "88人", "100min"],
          ["5号地块", "620次", "88人", "100min"],
          ["6号地块", "420次", "88人", "100min"],
          ["7号地块", "520次", "88人", "100min"],
          ["8号地块", "320次", "88人", "100min"],
          ["9号地块", "720次", "88人", "100min"],
        ],
        headerBGC: "",
        oddRowBGC: "",
        evenRowBGC: "",
        // index: true,
        columnWidth: [150],
        align: ["center"],
        // rowNum:6
      },
      AccessToken: "",
      imgShow:false,
      circleShow:false
    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;
    console.log(boundaryData);

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );
    let mapType1 = ref(
      L.tileLayer(
        "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    // let mapLabelType1 = ref(
    //   L.tileLayer(
    //     "https://t{s}.tianditu.gov.cn/" +
    //       "cva" +
    //       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
    //       "cva" +
    //       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();

    // 在 onMounted 中初始化地图
    onMounted(() => {
      // 获取视频AccessToken
      state.AccessToken = localStorage.getItem("AccessToken");
      console.log(state.AccessToken);
      const text = "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。";
      state.textList = chunkString(text, 15);
      


      map.value = L.map(mapRef.value, {
        center: [33.24715813736589, 114.12958145141602],

        // center: [114.182633, 33.240019],
        zoom: 13,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
      for (const markerDatum of markersData) {
        for (const latlng of markerDatum.locations) {
          const iconPath = require(`../assets/img/icon/new/${markerDatum.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48], // 图标大小
              iconAnchor: [22, 94], // 图标锚点
              popupAnchor: [-3, -76], // 弹出窗锚点
            }),
          });

          // 假设没有针对每个点定制的弹出内容，可以根据需求添加
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
          //   markerDatum.title ? markerDatum.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    });
    // 新增一个清除所有标记的方法
    function clearMarkers() {
      // 如果map.value存在并且有layers，则遍历删除所有标记
      if (map.value && map.value.eachLayer) {
        map.value.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.value.removeLayer(layer);
          }
        });
      }
    }
    // 假设有个按钮点击事件，用buttonClick表示
    function buttonClick(index) {
      // 清除所有已存在的标记
      clearMarkers();

      // 筛选出iconName为"1.png"的标记数据
      const filteredMarkers = markersData.find(
        (markerDatum) => markerDatum.iconName === index + ".png"
      );

      // 遍历筛选出来的标记数据，添加到地图上
      if (filteredMarkers) {
        for (const latlng of filteredMarkers.locations) {
          const iconPath = require(`../assets/img/icon/new/${filteredMarkers.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48],
              iconAnchor: [22, 94],
              popupAnchor: [-3, -76],
            }),
          });

          // 添加自定义的弹出内容
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
          //   filteredMarkers.title ? filteredMarkers.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    }

    // 定义一个函数用来创建和添加Marker
    function createAndAddMarker(latlng, options = {}) {
      const marker = L.marker(latlng, options);
      marker.addTo(map.value);
      return marker;
    }
    const markersData = [
      {
        locations: [
          [33.24496,114.19039],
          [33.24478,114.19031],
          [33.24477,114.19036],

          [33.26323568075217, 114.17610168457033],
          [33.2553408282391, 114.17541503906251],
          [33.24500467031837, 114.18107986450197],
          [33.233231446031674, 114.188289642334],
          [33.237538907121575, 114.202880859375],
          [33.238974680329434, 114.18348312377931],
          [33.26481456563577, 114.19515609741212]

        ],
        iconName: "1.png",
        // 其他相关属性...
      },
      // ...
      {
        locations: [

          [33.251895578102406, 114.14331436157228],
          [33.246440320912, 114.14417266845705],
          [33.243281858479484, 114.14485931396486],
          [33.250316459725, 114.13644790649415],
          [33.25132135653952, 114.14932250976564],
          [33.24744526229672, 114.15155410766603],
          [33.239118256353414, 114.14606094360353],

        ],
        iconName: "2.png",
        // 其他相关属性...
      },
      // ...
      {
        locations: [
          [33.2342147, 114.1648178], 
          [33.2521705, 114.1651687], 
          [ 33.2448196, 114.1902923], 
          [ 33.2342147, 114.1648178],
          [33.237019, 114.16764],
          [33.2448196, 114.1902923],
          [33.1868121, 114.185881],
          [ 33.235762, 114.164232],
          [33.2448196, 114.1902923],
          [33.235761, 114.1644],
          [ 33.2521705, 114.1651687],
          [33.2987955, 114.1845949],
          [33.244885, 114.189318],
          [33.2087364, 114.1830902],
          [33.236647, 114.167541],
          [33.245275, 114.190154],
          [33.239533, 114.191423],
        ],
        iconName: "3.png",
        // 其他相关属性...
      },
      // ...
      {
        locations: [
          [33.2553408282391, 114.13644790649415],
          [33.26366628855092, 114.14211273193361],
          [33.264096894226824, 114.14846420288086],
          [33.26610635931153, 114.1608238220215],
          [33.26208738291049, 114.15893554687501],
          [33.25921657226364, 114.15172576904298],
          [33.25749404059047, 114.14520263671876],
          [33.2684028342249, 114.15189743041994],
        ],
        iconName: "4.png",
        // 其他相关属性...
      },
      {
        locations: [
        [33.23107763591509, 114.17318344116212],
        [33.23782606364941, 114.1996192932129],
        [33.23811321923412, 114.20562744140626],
        [33.23337503148668, 114.20116424560548],
        [33.229354549629015, 114.20133590698244],
        [33.226482663712275, 114.20167922973634],
        [33.22073860899369, 114.20167922973634],
        [33.216861158847514, 114.20219421386719],
        [33.21872810073817, 114.20597076416017],
        ],
        iconName: "5.png",
        // 其他相关属性...
      },
      {
        locations: [
          [33.23409295522519, 114.17009353637695],
          [33.223323480291675, 114.20442581176759],
          [33.2738567201161, 114.19395446777345],
          [33.274000238828904, 114.1937828063965],
          [33.266680483701144, 114.18657302856447],
          [33.26495809920993, 114.2032241821289],
          [33.26553223114776, 114.17352676391603],
          [33.226913452611306, 114.18434143066408],
          [33.23811321923412, 114.21386718750001],
          [33.226769856547364, 114.21197891235353],
          [33.222031054189536, 114.20356750488281],



        ],
        iconName: "6.png",
        // 其他相关属性...
      },
    ];

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 0,
              };
              break;
            case "其他":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [1, 1],
                weight: 0,
              };
              break;
            default:
              style = {
                color: "#fff",
                fillColor: "red",
                fillOpacity: 0.25,
                dashArray: [1, 1],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };


    // 弹出视频
    function videoClick(index) {
      console.log(index);
      state.popShow = true;
      state.curVideoIndex = index;
    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }
    // 看大图
    function bigImg(){
      state.imgShow=true
    }
    function clickImg(){
      state.imgShow=false
    }

    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
    
    function chunkString(str, chunkSize) {
      if (str.length <= chunkSize) {
        return [str];
      }
      return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
    }

    onUnmounted(() => {
      removeMap();
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      mapRef,
      videoClick,
      popHiddlen,
      buttonClick,
      bigImg,
      clickImg,
      chunkString,
      circleHiddlen,
      clickNav
    };
  },
  components: {
    CircleNav,
    ldt,
    dczz,
    leftBar,
    footer1,
    txtScroll,
    popBg,
    Nav,
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}
.imgPopBg{
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  .closeIcon{
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 50px;
    font-size: 60px;
    color: #fff;
    opacity: .8;
  }
}
.map_dao {
  width: 1200px;
  height: 100px;
  display: flex;
  position: absolute;
  bottom: 20%;
  left: 35%;
  z-index: 9999999;

  background-color: #000;
  div {
    flex: 1;
    height: 100%;
    font-size: 30px;
    align-items: center;
    justify-content: center;
    color: #ecf6ff;
    border: 1px solid #19e1cb;
  }
}
.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 95px;
  background: linear-gradient( to bottom, rgba(3, 14, 25, 0.8) 0%,  rgba(3, 14, 25, 0.7) 60%,  rgba(3, 14, 25, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.containerBg {
  position: absolute;
  width: 100%;
  height: 100%;
  // background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/bg.png") no-repeat;
  z-index: 999;
}
.dk_ss {
  width: 250px;
  h6 {
    font-size: 15px;

    color: #00eaff;
    line-height: 30px;
    text-align: center;
  }
  .dot_w {
    width: 100%;
  }
  .dot {
    width: 90%;
    margin: 5px 5%;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    color: #000;
  }
  .dot:before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #00eaff;
    border-radius: 50%; /* 让其变成圆形 */
    margin-right: 6px;
  }
}
.bm-view {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}

.leftBg {
  width: 100px;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(0, 34, 25, 1) 0%,
    rgba(0, 34, 25, 0.8) 20%,
    rgba(0, 0, 0, 0)
  );
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.left_txt {
  width: 500px;
  height: 88%;
  position: absolute;
  top: 9%;
  left: 3%;
  display: flex;
  flex-direction: column;
  z-index: 10;
  .l_txt_top {
    width: 100%;
    height: 325px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/k/z1.png")
      no-repeat top center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .smallimg{
        cursor: pointer;
        height: 100%;
      }

    h6 {
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-size: 15px;
      margin-top: 22px;
      text-align: left;
      text-indent: 2em;
      color: #fff;
    }
    .sp {
      width: 100%;
      height: 280px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      .sp_n {
        width: 44%;
        height: 120px;
        margin-left: 4%;
        position: relative;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        .imgbg {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.2);
          top: 0;
          left: 0;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          img{
            width: 90%;
          }
        }
      }
    }
  }
  .l_txt_middle {
    width: 100%;
    flex: 1;
    margin: 10px 0;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/k/z2.png")
      no-repeat top center;
    background-size: 100% 100%;
    position: relative;

    h6 {
      width: 100%;
      height: 15%;
      position: absolute;
      // line-height: 160%;
      font-size: 15px;
      top: 3%;
      text-align: left;
      text-indent: 2em;
      color: #fff;
      display: flex;
      align-items: center; /* 垂直居中 */
    }
    .l_txt_nt {
      width: 94%;
      height: 75%;
      position: absolute;
      left: 5%;
      top: 18%;
      display: flex;
      img {
        margin-top: 10px;
      }
      .textScroll {
        width: 100%;
        // height: 100%;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
        padding: 0 0 10px 0;
        box-sizing: border-box;
        // animation: textScroll 4s linear infinite;
        overflow: hidden;
        font-size: 14px;
        text-align: left;
        color: #fff;

      }
    }
  }
  .l_txt_bottom {
    width: 100%;
    flex: 1;
    margin: 10px 0;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/k/z3.png")
      no-repeat top center;
    background-size: 100% 100%;
    position: relative;

    h6 {
      width: 100%;
      height: 15%;
      position: absolute;
      // line-height: 160%;
      font-size: 15px;
      top: 3%;
      text-align: left;
      text-indent: 2em;
      color: #fff;
      display: flex;
      align-items: center; /* 垂直居中 */
    }
    .l_txt_b_n {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0%;
      display: flex;
      align-items: center;
      justify-content: center;
      .ld {
        width: 55%;
        height: 100%;
      }
      .cl {
        width: 45%;
        height: 100%;
      }
    }
  }
}
.db_dh {
  width: 950px;
  height: 66px;
  position: absolute;
  left: 39%;
  bottom: 10%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/dc.png")
    no-repeat top center;
  background-size: 100% 100%;
  z-index: 10;
}
.d_h_n_r {
  width: 950px;
  height: 100px;
  position: absolute;
  z-index: 10;
  // border: #fff 1px solid;
  left: 39%;
  bottom: 11%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 20px;
  .sbx_b {
    width: 105px;
    height: 100px;
    transform: scale(1.3);
    // border: #3bf4be 1px solid;
    cursor: pointer;
    .xz_sbx {
      width: 60px;
      height: 66px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/wq.png")
        no-repeat top center;
      background-size: 100% 100%;
      margin-left: 22.5px;
      position: relative;
      // animation: guangying 3s linear infinite;
    }
    .xz_bj {
      width: 73px;
      height: 80px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/jb.gif")
        no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      top: -9px;
      margin-left: 15px;
    }
    .b_name {
      width: 100%;
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      color: #fff;
      text-align: center;
    }
  }
}


@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
//@keyframes scroll-left{
//  0% { transform: translateY(0)}
//  100% { transform: translateY(-100%)}
//}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(0.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
  100% {
    transform: rotate(0);
  }
}

#video .d-player-wrap .d-player-control {
  height: 50px;
}
</style>
